// 设备温湿度详情
<template>
  <div class="DkbFNARADeviceTHInfo">
    <p class="title">当前设备温湿度详情</p>
    <div class="GaugeArea">
      <div class="Gauge">
        <div class="chart" id="nowTD"></div>
        <p class="text">当前温度</p>
      </div>
      <div class="Gauge">
        <div class="chart" id="nowHD"></div>
        <p class="text">当前湿度</p>
      </div>
    </div>
    <div class="selectArea">
      <span
        :class="['text', {'active': item.value === nowTimeType }]"
        v-for="(item, index) in timeTypeList"
        :key="index"
        @click="selectTimeType(item.value)"
      >{{item.label}}</span>
    </div>
    <div class="tooltipArea">
      <p class="text">温度</p>
      <p class="text H">湿度</p>
    </div>
    <div class="mixChart" id="THMixD"></div>
    <!-- 设备列表 -->
    <div class="dSwiperArea" v-if="DeviceList.length !== 0 && swiperOption.slidesPerView">
      <swiper class="deviceList" :options="swiperOption" ref="deviceList">
        <swiper-slide
          :class="['dSwiperItem', {'active': index === activeS}]"
          v-for="(item, index) in DeviceList"
          :key="index"
        >
          <p class="text one-line-overhidden" @click="clickSwiperItem(index)">{{item.DeviceName}}</p>
        </swiper-slide>
      </swiper>
      <div
        :class="['swiper-button swiper-button-prev swiper-button-prev2', {'opacity': swiperNum<=3}]"
        slot="button-prev"
        @click="slideToLoopGetInfo('prev')"
      ></div>
      <div
        :class="['swiper-button swiper-button-next swiper-button-next2', {'opacity': swiperNum<=3}]"
        slot="button-next"
        @click="slideToLoopGetInfo('next')"
      ></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { dkbApi } from "../../../../../../static/js/dkb/dkb.js";
import { showToast } from "../../../../../../static/js/utility/utility.js";
let echarts = require("echarts");
let vm, Timer;

export default {
  name: "DkbFNARADeviceTHInfo",
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    // 父组件传来的参数
    sInfo: {
      type: Object,
      default: {},
    },
  },
  computed: {},
  data() {
    return {
      // 轮播图
      swiperOption: {},
      swiperNum: 0,
      activeS: 0,

      /* 温湿度 */
      timeTypeList: [
        // 时间类型，1为天，2为周，3为月
        {
          value: 1,
          label: "天",
        },
        {
          value: 2,
          label: "周",
        },
        {
          value: 3,
          label: "月",
        },
      ],
      nowTimeType: 1, // 当前显示
      DeviceTHInfo: {},
      DeviceList: [],
    };
  },
  created() {
    vm = this;
    console.log("sInfo", vm.sInfo);
    vm.DeviceTHInfo = vm.sInfo.DeviceTHInfo;
    vm.DeviceList = vm.sInfo.DeviceList;
    // vm.DeviceList = [
    //   {DeviceId: 1, DeviceName: '1111'},
    //   {DeviceId: 2, DeviceName: '2222'},
    //   {DeviceId: 3, DeviceName: '3333'},
    //   {DeviceId: 4, DeviceName: '4444'},
    //   {DeviceId: 5, DeviceName: '5555'},
    // ]
    vm.swiperNum = vm.DeviceList.length;
    vm.swiperOption = {
      slidesPerView: vm.DeviceList.length > 3 ? 3 : vm.DeviceList.length,
      spaceBetween: (9 / 100) * this.$store.state.htmlFontSize,
      noSwipingClass: "text",
      on: {
        slideChange() {
          console.log("swiper执行的索引", this.realIndex);
        },
      },
    };
  },
  mounted() {
    vm.$nextTick(() => {
      vm.drawHTChart();
    });
    vm.timeRefresh();
  },
  destroyed() {
    clearInterval(Timer);
  },
  methods: {
    // 点击切换设备并获取信息
    slideToLoopGetInfo(type) {
      clearInterval(Timer);
      vm.slideToLoop(type);
      vm.GetDeviceTHInfo();
      vm.timeRefresh();
    },
    // 点击左右切换Index
    slideToLoop(type) {
      let swiper = vm.$refs.deviceList.swiper;
      let i;
      if (type === "prev") {
        i = vm.activeS === 0 ? vm.DeviceList.length - 1 : vm.activeS - 1;
      } else {
        i = vm.activeS === vm.DeviceList.length - 1 ? 0 : vm.activeS + 1;
      }
      swiper.slideToLoop(i);
      vm.activeS = i;
    },
    // 点击轮播设备item
    clickSwiperItem(index) {
      clearInterval(Timer);
      vm.activeS = index;
      vm.GetDeviceTHInfo();
      vm.timeRefresh();
    },

    // 定时刷新数据
    timeRefresh() {
      Timer = setInterval(() => {
        vm.slideToLoop("next");
        vm.GetDeviceTHInfo();
      }, 1000 * 10);
    },
    // 获取档案馆温湿度详情
    async GetDeviceTHInfo() {
      console.log("vm.activeS设备", vm.activeS);
      let data = {
        nowTimeType: vm.nowTimeType,
        DeviceId: vm.DeviceList[vm.activeS].DeviceId,
      };
      let res = await dkbApi.GetDeviceTHInfo(data);
      // console.log('res', res)
      if (res.ErrCode === 0) {
        vm.DeviceTHInfo = res.Result.DeviceTHInfo;
        // 绘制图表
        vm.drawHTChart();
      } else {
        showToast(res.ErrMsg);
      }
    },
    // 选择时间类型
    selectTimeType(val) {
      vm.nowTimeType = val;
      clearInterval(Timer);
      vm.GetDeviceTHInfo();
      vm.timeRefresh();
    },
    // 绘制温湿度图表
    drawHTChart() {
      vm.getTChart("nowTD", "NowT");
      vm.getHChart("nowHD", "NowH");
      vm.getMixChart("THMixD", "THMix");
    },
    // 获取湿度仪表
    getHChart(id, vid) {
      let myChart = echarts.init(document.getElementById(id));
      let htmlFontSize = vm.$store.state.htmlFontSize;
      let dataVlaue = vm.DeviceTHInfo[vid];

      let option = {
        grid: {
          left: "0",
          right: "0",
          top: 0,
          bottom: "0",
          containLabel: true,
        },
        tooltipArea: {
          formatter: "{a} : {c}℃",
        },
        series: [
          {
            name: "仪表盘",
            type: "gauge",
            radius: "100%",
            min: 0,
            max: 100,
            splitNumber: 5,
            // 轴线
            axisLine: {
              lineStyle: {
                width: (10 / 100) * htmlFontSize,
                color: [
                  [0.2, "#6cc4bd"],
                  [0.8, "#51c1e1"],
                  [1, "#ea5413"],
                ],
              },
            },
            // 刻度标签
            axisLabel: {
              distance: (2 / 100) * htmlFontSize,
              fontSize: (8 / 100) * htmlFontSize,
              formatter: "{value}",
            },
            // 分割线
            splitLine: {
              length: (10 / 100) * htmlFontSize,
              lineStyle: {
                opacity: 0,
              },
            },
            // 刻度
            axisTick: {
              splitNumber: 1,
              length: (10 / 100) * htmlFontSize,
              lineStyle: {
                color: "#093053",
              },
            },
            // 指针
            pointer: {
              show: true,
              length: (25 / 100) * htmlFontSize,
              width: (2 / 100) * htmlFontSize, //指针粗细
            },
            detail: {
              formatter: "{value}%",
              color: "#51c1e1",
              fontSize: (12 / 100) * htmlFontSize,
              offsetCenter: [0, "62.5%"],
            },
            data: [{ value: dataVlaue }],
          },
        ],
      };
      myChart.setOption(option, true);
      // setInterval(function () {
      //   option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0

      // },2000)
    },
    // 获取温度仪表
    getTChart(id, vid) {
      let myChart = echarts.init(document.getElementById(id));
      let htmlFontSize = vm.$store.state.htmlFontSize;
      let dataVlaue = vm.DeviceTHInfo[vid];

      let option = {
        grid: {
          left: "0",
          right: "0",
          top: 0,
          bottom: "0",
          containLabel: true,
        },
        tooltipArea: {
          formatter: "{a} : {c}℃",
        },
        series: [
          {
            name: "仪表盘",
            type: "gauge",
            radius: "100%",
            min: -50,
            max: 50,
            splitNumber: 5,
            // 轴线
            axisLine: {
              lineStyle: {
                width: (10 / 100) * htmlFontSize,
                color: [
                  [0.2, "#6cc4bd"],
                  [0.8, "#51c1e1"],
                  [1, "#ea5413"],
                ],
              },
            },
            // 刻度标签
            axisLabel: {
              distance: (2 / 100) * htmlFontSize,
              fontSize: (8 / 100) * htmlFontSize,
              // padding: [0, (10/100)*htmlFontSize, 0, 0],
              formatter: function (value) {
                return value;
                // return Math.abs(value)
              },
            },
            // 分割线
            splitLine: {
              length: (10 / 100) * htmlFontSize,
              lineStyle: {
                opacity: 0,
              },
            },
            // 刻度
            axisTick: {
              splitNumber: 1,
              length: (10 / 100) * htmlFontSize,
              lineStyle: {
                color: "#093053",
              },
            },
            // 指针
            pointer: {
              show: true,
              length: (25 / 100) * htmlFontSize,
              width: (2 / 100) * htmlFontSize, //指针粗细
            },
            detail: {
              formatter: function (value) {
                return value + "℃";
              },
              color: "#51c1e1",
              fontSize: (12 / 100) * htmlFontSize,
              offsetCenter: [0, "62.5%"],
            },
            data: [{ value: dataVlaue }],
          },
        ],
      };
      myChart.setOption(option, true);
      // setInterval(function () {
      //   option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0

      // },2000)
    },
    // 获取温湿度混合图表数据
    getMixChartData() {
      let list = [...vm.DeviceTHInfo.List];
      let nowTimeType = vm.nowTimeType;
      let xInterval = nowTimeType === 1 ? 6 : nowTimeType === 2 ? 0 : 8;
      let xData = [],
        TValArr = [],
        TMinB = 0,
        TMaxB = 5,
        HValArr = [],
        HMaxB = 5;
      list.forEach(function (item, index) {
        xData.push(item.Label);
        let TB = Math.ceil(item.TValue / 10);
        let TBm = Math.floor(item.TValue / 10);
        if (TB > TMaxB) {
          TMaxB = TB;
        }
        if (TBm < TMinB) {
          TMinB = TBm;
        }
        TValArr.push(item.TValue);
        let HB = Math.ceil(item.HValue / 10);
        if (HB > HMaxB) {
          HMaxB = HB;
        }
        HValArr.push(item.HValue);
      });
      let TMinVal = TMinB * 10;
      let TMaxVal = TMaxB * 10;
      let HMaxVal = HMaxB * 10;
      return { xData, xInterval, TValArr, TMinVal, TMaxVal, HValArr, HMaxVal };
    },
    // 获取温湿度混合图表
    getMixChart(id) {
      // 获取数据
      let {
        xData,
        xInterval,
        TValArr,
        TMinVal,
        TMaxVal,
        HValArr,
        HMaxVal,
      } = vm.getMixChartData();

      let myChart = echarts.init(document.getElementById(id));
      let htmlFontSize = vm.$store.state.htmlFontSize;
      let getSeriesItemStyle = function (isH) {
        let seriesItemStyle = {
          normal: {
            opacity: 0,
            color: "transparent",
            borderWidth: 0,
          },
          emphasis: {
            opacity: 1,
            color: "#ffffff",
            shadowColor: "rgba(81, 193, 225, 0.58)",
            shadowBlur: 3,
            label: {
              show: true,
              position: [(10 / 100) * htmlFontSize, -(15 / 100) * htmlFontSize],
              color: "#fff",
              fontSize: (12 / 100) * htmlFontSize,
              padding: [0, (5 / 100) * htmlFontSize],
              lineHeight: (13 / 100) * htmlFontSize,
              width: (34 / 100) * htmlFontSize,
              height: (13 / 100) * htmlFontSize,
              formatter(params) {
                return params.data + (isH ? "%" : "℃");
              },
            },
          },
        };
        return seriesItemStyle;
      };

      let option = {
        grid: {
          top: (35 / 100) * htmlFontSize,
          bottom: (5 / 100) * htmlFontSize,
          left: 0,
          right: (2 / 100) * htmlFontSize,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            position: "bottom",
            // boundaryGap: true,
            data: xData,
            // 指示线
            axisPointer: {
              show: true,
              type: "line",
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#368bac",
              },
            },
            // 刻度
            axisTick: {
              show: false, // 不显示刻度
            },
            // 坐标轴
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#2f7d9f", // 坐标轴颜色
              },
            },
            axisLabel: {
              interval: xInterval,
              showMaxLabel: true,
              color: "#51c1e1",
              fontSize: (10 / 100) * htmlFontSize,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // name: '温度',
            // nameTextStyle: {
            //   padding: [0, 0, -(10/100)*htmlFontSize, -(25/100)*htmlFontSize],
            //   color: '#92bd37'
            // },
            min: TMinVal,
            max: TMaxVal,
            interval: 10,
            axisTick: {
              // 刻度
              show: false, // 不显示刻度
            },
            axisLine: {
              //坐标轴
              lineStyle: {
                color: "#3b95b6", // 坐标轴颜色
              },
            },
            axisLabel: {
              //刻度标签
              show: false,
              interval: 0,
              color: "#92bd37",
              fontSize: (10 / 100) * htmlFontSize,
              formatter: "{value}",
            },
            splitLine: {
              //分割线
              lineStyle: {
                color: "#1b5477",
              },
            },
            markPoint: {
              // 标注
              symbol: "circle",
            },
          },
          {
            type: "value",
            // name: '湿度',
            // nameTextStyle: {
            //   padding: [0, -(25/100)*htmlFontSize, -(10/100)*htmlFontSize, 0],
            //   color: '#e99314'
            // },
            min: 0,
            max: HMaxVal,
            interval: 10,
            axisTick: {
              show: false, // 不显示刻度
            },
            axisLine: {
              lineStyle: {
                color: "#3b95b6", // 坐标轴颜色
              },
            },
            axisLabel: {
              show: false,
              interval: 0,
              color: "#e99314",
              fontSize: (10 / 100) * htmlFontSize,
              formatter: "{value}",
            },
            splitLine: {
              //分割线
              lineStyle: {
                color: "#1b5477",
              },
            },
          },
        ],
        series: [
          {
            name: "温度",
            type: "line",
            yAxisIndex: 0,
            data: TValArr,
            lineStyle: {
              width: (5 / 100) * htmlFontSize,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#92bd37", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#ffffff", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              backgroundColor: {
                image: "/static/images/dkb/NARA/tv_bg.png",
              },
            },
            itemStyle: getSeriesItemStyle(),
          },
          {
            name: "湿度",
            type: "line",
            yAxisIndex: 1,
            data: HValArr,
            lineStyle: {
              width: (5 / 100) * htmlFontSize,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#e99314", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#ffffff", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            label: {
              backgroundColor: {
                image: "/static/images/dkb/NARA/hv_bg.png",
              },
            },
            itemStyle: getSeriesItemStyle("isH"),
          },
        ],
      };
      myChart.setOption(option, true);
    },

    // 屏幕变化图表自适应加载
    resizeGetChart() {
      echarts.init(document.getElementById("nowTD")).resize();
      echarts.init(document.getElementById("nowHD")).resize();
      echarts.init(document.getElementById("THMixD")).resize();
    },
  },
  watch: {
    // 屏幕变化，图表自适应加载
    "$store.state.isOnresize"(newVal, oldVal) {
      if (newVal !== oldVal) {
        vm.resizeGetChart();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.DkbFNARADeviceTHInfo {
  width: 100%;
  height: 100%;
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  .title {
    width: 100%;
    padding: 0.15rem 0 0.1rem;
    font-size: 0.15rem;
    line-height: 1;
    text-align: center;
  }
  .selectArea {
    margin: 0.24rem 0 0;
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0.34rem;
    top: 1.2rem;
    margin: auto;
    z-index: 10;
    .text {
      padding-top: 0.08rem;
      color: #51c1e1;
      font-size: 0.12rem;
      position: relative;
    }
    .text + .text {
      margin-left: 0.12rem;
    }
    .text:before {
      content: "";
      display: block;
      width: 0.03rem;
      height: 0.03rem;
      border-radius: 50%;
      border: 0.01rem solid #51c1e1;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
    .text.active:before {
      background-color: #51c1e1;
      box-shadow: 0 0 0.03rem rgba(81, 793, 225, 0.58);
    }
  }
  .tooltipArea {
    margin: 0.24rem 0 0;
    display: flex;
    justify-content: center;
    position: absolute;
    right: 0.34rem;
    top: 1.3rem;
    margin: auto;
    z-index: 10;
    .text {
      padding-left: 0.12rem;
      color: #93be37;
      font-size: 0.1rem;
      position: relative;
      &:before {
        content: "";
        display: block;
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 50%;
        background-color: #93be37;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto;
      }
      &.H {
        color: #e99314;
        margin-left: 0.1rem;
        &:before {
          background-color: #e99314;
        }
      }
    }
  }
  .GaugeArea {
    flex-shrink: 0;
    width: 100%;
    padding: 0 0.8rem;
    display: flex;
    justify-content: space-between;
    .Gauge {
      width: 1.06rem;
      height: 0.76rem;
      .chart {
        width: 0.76rem;
        height: 0.76rem;
        margin: 0 auto;
        position: relative;
      }
      .chart:before {
        content: "";
        display: block;
        width: 0.07rem;
        height: 0.07rem;
        box-sizing: border-box;
        border-radius: 50%;
        border: 0.02rem solid #51c1e1;
        background-color: #093053;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        z-index: 9;
      }
      .text {
        width: 1rem;
        font-size: 0.15rem;
        line-height: 0.2rem;
        text-align: center;
        margin-top: -0.08rem;
        color: #51c1e1;
      }
    }
  }
  .mixChart {
    width: 100%;
    height: 100%;
    // height: 0.8rem;
    // margin-top: 0.45rem;
  }
  .dSwiperArea {
    width: 100%;
    height: 0.34rem;
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0.19rem;
    &::before {
      display: block;
      content: "";
      width: 4.45rem;
      height: 0.34rem;
      background-color: #072a4b;
      position: absolute;
      top: 0;
      left: 0.49rem;
    }
    .deviceList {
      width: 4.29rem;
      height: inherit;
      padding-top: 0.06rem;
      // background-color: #072a4b;
      position: relative;
      .dSwiperItem {
        height: 0.21rem;
        text-align: center;
        background-color: #103d5d;
        box-sizing: border-box;
        &.active {
          border: 1px solid #7ca2c6;
          box-shadow: 0 0 0.03rem rgba(122, 160, 195, 0.39);
        }
        .text {
          width: 100%;
          height: 100%;
          font-size: 0.15rem;
        }
      }
    }
    .swiper-button {
      width: 0.1rem;
      height: 0.11rem;
      color: #7ca9d0;
      background: url("/static/images/dkb/NARA/swiper_icon2.png") center
        no-repeat;
      background-size: 0.1rem 0.11rem;
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 99;
      margin: auto;
      &.opacity {
        opacity: 0;
      }
      &.swiper-button-prev {
        transform: rotate(180deg);
        left: 0.3rem;
      }
      &.swiper-button-next {
        right: 0.3rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/NARA/SwiperSlide/DeviceTHInfo.vue